import React from "react";
import { useTranslation } from "react-i18next";
import { RevFlexSection, FlexSection, FullWidthSection, FullWidthImage, ImageSubtitle } from "./styles";
import { ResponsiveImage } from "components/ResponsiveImage";
import { ContentDiv } from "components/containers";
import { StyledButton } from "components/generic";
import { useNavigate } from "react-router-dom";
import { BLOG_ROUTE, REGISTER_ROUTE } from "../../../utils/constants";
import { Button, NavButton } from "components/Button";

export const Mission: React.FC = () => {
    const { t, i18n } = useTranslation('mission');
    const navigate = useNavigate();

    return (
        <ContentDiv>
            <h1>{t("mission.title")}</h1>
            <RevFlexSection>
                <ResponsiveImage
                    imgSrc={"rootpage/mission/hospitaharen01"}
                    className={"image"}
                    mobileSize={"95vw"}
                    tabletSize={"30vw"}
                    desktopSize={"40vw"}
                />
                <div>
                    <h3>{t("mission.missionSection.header")}</h3>
                    <h2>{t("mission.missionSection.title")}</h2>
                    <p>{t("mission.missionSection.description")}</p>
                </div>
            </RevFlexSection>
            <section>
                <FullWidthImage>
                    <ResponsiveImage
                        imgSrc={"rootpage/mission/hospitabrug32"}
                        className={"image"}
                        mobileSize={"200vw"}
                        tabletSize={"200vw"}
                        desktopSize={"200vw"}
                    />
                </FullWidthImage>
                <ImageSubtitle>{t("mission.photoSubtitle")}</ImageSubtitle>
            </section>
            <RevFlexSection>
                <ResponsiveImage
                    imgSrc={"rootpage/mission/missionorigin"}
                    className={"missionimage"}
                    mobileSize={"95vw"}
                    tabletSize={"30vw"}
                    desktopSize={"40vw"}
                />
                <div>
                    <h3>{t("mission.originSection.header")}</h3>
                    <h2>{t("mission.originSection.title")}</h2>
                    <p>{t("mission.originSection.description")}</p>
                    <StyledButton
                        onClick={() => navigate(`/${i18n.language}${BLOG_ROUTE.slice(5)}/post12`)}
                    >{t("mission.originSection.button")}</StyledButton>
                </div>
            </RevFlexSection>
            <FlexSection>
                <ResponsiveImage
                    imgSrc={"rootpage/mission/hospita2"}
                    className={"image"}
                    mobileSize={"95vw"}
                    tabletSize={"30vw"}
                    desktopSize={"40vw"}
                />
                <div>
                    <h3>{t("mission.revivalSection.header")}</h3>
                    <h2>{t("mission.revivalSection.title")}</h2>
                    <p>{t("mission.revivalSection.description")}</p>
                </div>
            </FlexSection>
            <FullWidthSection>
                <h3>{t("mission.enrichingSection.header")}</h3>
                <h2>{t("mission.enrichingSection.title")}</h2>
                <p>{t("mission.enrichingSection.description")}</p>
                <hr />
                <span>Daan Donkers - Founder</span>
            </FullWidthSection>
            <RevFlexSection lastMember>
                <ResponsiveImage
                    imgSrc={"rootpage/press/team"}
                    className={"missionimage"}
                    mobileSize={"95vw"}
                    tabletSize={"30vw"}
                    desktopSize={"40vw"}
                />
                <div>
                    <h3>{t("mission.joinSection.header")}</h3>
                    <h2>{t("mission.joinSection.title")}</h2>
                    <p>{t("mission.joinSection.description")}</p>
                    <StyledButton
                        onClick={() => navigate(`/${i18n.language}${REGISTER_ROUTE.slice(5)}`)}
                    >{t("mission.joinSection.button")}</StyledButton>
                </div>
            </RevFlexSection>
        </ContentDiv>
    );
}
